import { LiveTopic } from '../live-topics-types';

/**
 * Returns the display summary for a topic: refined_summary when present and non-empty, otherwise summary.
 */
export function getTopicDisplaySummary(topic: LiveTopic): string {
  if (topic.refined_summary) {
    return topic.refined_summary;
  }

  return topic.summary;
}
